import ReferenceControleDetailController from './reference.controle.detail.controller';

export default {
    template: require('./reference.controle.detail.html'),
    controller: ReferenceControleDetailController
};
